<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData">
      <template v-slot:slotRemarkData="update">
        <!--语言说明-->
        <slotRemark :update="update"></slotRemark>
      </template>
    </UPDATE>
    <el-dialog ref="proposalDialog" :title="$t('crs.bt.proposal')" :visible.sync="dialogStatus.dialogVisible"
               width="30%"
               :before-close="handleClose"
    >
      <el-select value="" v-model="dialogStatus.statusType" style="margin-top: 10px">
        <el-option value="" v-for="option in dialogStatus.statusData" :label="option.value"
                   :value="option.key"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-input type="textarea" :rows="4" :placeholder="$t('crs.bt.proposal')" maxlength="100" show-word-limit
                  v-model="dialogStatus.reason"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('crs.bt.close') }}</el-button>
          <el-button type="primary" @click="statusConfirm">{{ $t('crs.bt.confirm') }}</el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
import slotRemark from '@/views/crs/quantitytask/slotRemark.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'

let statusArr = { 0: '未審覈', 1: '已通過', 2: '未通過' }
let quantityTypes = {
  1: '活動',
  2: '系統返利'
}
let activityTypeList = [], activityTypeArr = {}
let slotRemarkData = [{ title: '', language: '' }]
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE,
    slotRemark
  },
  created() {
    this.initCategoryTasks()
  },
  methods: {
    editNodes(data) {
      let newData = []
      for (const i in data) {
        data[i].value = data[i].taskId || data[i].category
        data[i].label = data[i].taskName || data[i].name
        data[i].children = data[i].taskDetailList || []
        if (data[i].children && data[i].children.length > 0) {
          this.editNodes(data[i].children)
        }
      }
      newData = data
      return newData
    },
    delNodes(nodes = []) {
      for (let item of nodes) {
        if (!item.children || item.children.length <= 0) {
          delete item.children
        } else {
          this.delNodes(item.children)
        }
      }
      return nodes
    },
    addNodes(data) {
      for (let i in data) {
        activityTypeArr[data[i].value] = data[i].label
        if (data[i].children && data[i].children.length > 0) {
          this.addNodes(data[i].children)
        }
      }
      return activityTypeArr
    },
    initCategoryTasks() {
      this.$axios.get(Url.quantityTask.dailyTaskCategory, {
        params: {
          businessTypeAlias: DateUtil.getParamKey(this.$route.params)
        }
      }).then(res => {
        if (res.code == 0) {
          let data = this.editNodes(JSON.parse(JSON.stringify(res.result)))
          this.delNodes(data)
          this.updateData.cols.find(function(e) {
            return e.field == 'category'
          }).optionList = data
          activityTypeList = data
          this.addNodes(data)
          this.$refs.childTable.defaultQueryData(this.queryData)
        }
      })
    },
    handleClose() {
      this.dialogStatus.reason = ''
      this.dialogStatus.dialogVisible = false
    },
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('common.add') == clickName || '增加' == clickName) {
        this.$refs.childUpdate.open()
      }
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        row.values = JSON.parse(row.values)
        row.category = [row.category, row.taskId]
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'proposal') {
        this.dialogStatus.dialogVisible = true
        this.dialogStatus.row = row
      } else if (clickName == 'delete') {
        this.dataChange(Url.quantityTask.proposalDel, row, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.taskId = model.category[1]
      model.category = model.category[0]
      model.values = JSON.stringify(model.values)
      this.dataChange(Url.quantityTask.proposalEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    statusConfirm() {
      this.dialogStatus.row.status = this.dialogStatus.statusType
      this.dialogStatus.row.remark = this.dialogStatus.reason
      this.dataChange(Url.quantityTask.proposalStatus, this.dialogStatus.row, res => {
        if (res.code == 0) {
          this.$refs.proposalDialog.hide()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  data() {
    return {
      deleteIds: '',
      dialogStatus: {
        statusData: [{ value: '同意', key: 1 }, { value: '不同意', key: 2 }],
        statusType: 1,
        dialogVisible: false,
        reason: '',
        row: {}
      },
      queryData: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '提案標題', field: 'title', required: true },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', required: true },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'type',
            type: 2,
            optionList: quantityTypes,
            data: [],
            required: true,
            isNumber: true
          },
          {
            title: '活动分类',
            field: 'category',
            type: 15,
            optionList: activityTypeList,
            data: [],
            checkStrictly: false,
            hidden: (model, col) => {
              return model.type == 1 ? false : true
            }
          },
          {
            title: '条件组',
            field: 'values',
            type: 10,
            slot: 'slotRemarkData',
            data: slotRemarkData,
            arr: { title: '', language: '' },
            hidden: (model, col) => {
              return model.type == 2 ? false : true
            }
          },
          { title: window.$t('crs.quantityTask.quantity'), field: 'quantity', isNumber: true, required: true }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', isNumber: true },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'type',
            type: 2,
            optionList: quantityTypes,
            data: []
          },
          {
            title: window.$t('crs.quantityTask.status'),
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },

          { click: window.$t('common.search') },
          { click: window.$t('common.add'), auth: 'crs:quantityTask:add' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.quantityTask.proposalQuery,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: 'ID', field: 'id' },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          { title: '提案標題', field: 'title' },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone' },
          { title: window.$t('crs.quantityTask.userName'), field: 'name' },
          { title: window.$t('crs.quantityTask.taskId'), field: 'taskId' },
          { title: window.$t('crs.quantityTask.taskName'), field: 'taskName' },
          {
            title: window.$t('crs.quantityTask.type'), field: 'type', render: (data, full) => {
              return quantityTypes[data]
            }
          },
          { title: window.$t('crs.quantityTask.quantity'), field: 'quantity' },
          {
            title: window.$t('crs.quantityTask.status'), field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: window.$t('crs.quantityTask.uname'), field: 'uname' },
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: window.$t('crs.quantityTask.utime'), field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },

          { title: window.$t('crs.quantityTask.businessType'), field: 'businessType' },
          { title: window.$t('crs.common.remark'), field: 'remark' },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: window.$t('crs.bt.proposal'),
                click: 'proposal',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'crs:quantityTask:proposal',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              },
              {
                name: window.$t('crs.bt.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'crs:quantityTask:del',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              },
              {
                name: window.$t('crs.bt.edit'),
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'crs:quantityTask:edit',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              }]
          }
        ]
      }
    }
  }
}
</script>
